import {z} from 'zod';

import i18n from '@dms/i18n';

const RATE_INTEGER_PATTERN = /^\d{1,3}$/;
const RATE_DECIMAL_PATTERN = /^\d{1,3}[.,]\d{1,2}$/;
const MAX_RATE_PERCENT = 100;

const toRateNumber = (value: string) => Number(value.replace(',', '.'));

const isDecimalRateString = (value: string) =>
  (RATE_INTEGER_PATTERN.test(value) || RATE_DECIMAL_PATTERN.test(value)) &&
  toRateNumber(value) <= MAX_RATE_PERCENT;

const decimalRateSchema = z
  .string()
  .trim()
  .min(1, {message: i18n.t('general.errors.mixed.required')})
  .refine(isDecimalRateString, {message: i18n.t('general.errors.mixed.invalid')})
  .transform((value) => toRateNumber(value).toString());

export const rateMatrixCellFormSchema = z.object({
  nominalRate: decimalRateSchema,
  apr: decimalRateSchema,
});

export type RateMatrixCellFormValues = z.infer<typeof rateMatrixCellFormSchema>;
